import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { browserAppearancePreference } from '../src/services/adapters/browserAppearancePreference';
import { browserUiDensityPreference } from '../src/services/adapters/browserUiDensityPreference';
import { AppearanceProvider } from '../src/shell/AppearanceProvider';
import { assertCpqShellBase } from '../src/shell/runtimePaths';
import { UiDensityProvider } from '../src/shell/UiDensityProvider';
import { ViteCpqShell } from '../src/shell/ViteCpqShell';
import './styles/global.css';
import '../src/shell/appearance.css';

assertCpqShellBase(import.meta.env.BASE_URL);

if (import.meta.env.VITE_CPQ_PERFORMANCE_ENABLED === 'true') {
  void import('../src/shell/workbenchPerformance').then((module) => {
    const dispose = module.installWorkbenchPerformanceTiming();
    import.meta.hot?.dispose(dispose);
  });
}

const root = document.getElementById('cpq-vite-root');
if (!root) throw new Error('缺少 CPQ Vite 根节点');

createRoot(root).render(
  <StrictMode>
    <AppearanceProvider preference={browserAppearancePreference}>
      <UiDensityProvider preference={browserUiDensityPreference}>
        <ViteCpqShell />
      </UiDensityProvider>
    </AppearanceProvider>
  </StrictMode>,
);
